import { ModifiedPerkItem } from "types/healthyPerk";
import { Loyalty } from "types/loyalty";

export const TabNames = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

export const columns = [
  {
    title: "Image",
    dataIndex: ["product", "imageURL"],
    key: "image",
    width: 80,
  },
  {
    title: "Name",
    dataIndex: ["product", "name"],
    key: "product",
  },
  {
    title: "Description",
    dataIndex: ["product", "description"],
    key: "description",
  },
  {
    title: "Loyalty tiers",
    dataIndex: "tiers",
    key: "tiers",
    render: (_: unknown, record: ModifiedPerkItem) => {
      return (
        record?.tiersData?.map((tier: Loyalty) => tier.name).join(", ") || "-"
      );
    },
  },
];
